// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
import { SVGProps } from 'react';

const SvgCheck12 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 12 12"
		{...props}
	>
		<path
			fill="currentColor"
			d="M9.258 2.25 4.203 7.85l-1.842-2.04a.763.763 0 0 0-.565-.25.766.766 0 0 0-.56.26.94.94 0 0 0-.236.622.944.944 0 0 0 .225.626l2.41 2.67c.151.167.355.261.568.261a.766.766 0 0 0 .568-.26l5.623-6.231a.944.944 0 0 0 .226-.627.94.94 0 0 0-.236-.621.766.766 0 0 0-.56-.261.763.763 0 0 0-.566.25Z"
		/>
	</svg>
);
export default SvgCheck12;
